var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"base-image",style:(_vm.computedStyle),attrs:{"src":_vm.computedSrc},on:{"error":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }